module.exports = __webpack_public_path__ + "static/media/harsh.d8fec4f0.jfif";